document.addEventListener('DOMContentLoaded', () => {
	const triggers = document.querySelectorAll('.hurome-faq__trigger')

	const getContents = (btn) => {
		const id = btn.getAttribute('aria-controls')
		return id ? document.getElementById(id) : null
	}

	const getIcon = (btn) => {
		return btn.querySelector('.accordion-icon') || btn.closest('.hurome-faq__item')?.querySelector('.accordion-icon')
	}

	const collapse = (btn) => {
		const contents = getContents(btn)
		const icon = getIcon(btn)
		btn.setAttribute('aria-expanded', 'false')
		if (contents) {
			contents.style.maxHeight = contents.scrollHeight + 'px' // 현재 높이 고정
			requestAnimationFrame(() => {
				contents.style.maxHeight = 0
			})

			// transition이 끝나면 hidden 처리
			// const onTransitionEnd = (e) => {
			// 	if (e.propertyName === 'max-height') {
			// 		contents.hidden = true
			// 		contents.removeEventListener('transitionend', onTransitionEnd)
			// 	}
			// }
			// contents.addEventListener('transitionend', onTransitionEnd)
		}
		icon?.classList.remove('active')
	}

	const expand = (btn) => {
		const contents = getContents(btn)
		const icon = getIcon(btn)
		btn.setAttribute('aria-expanded', 'true')
		if (contents) {
			contents.hidden = false // 열기 전에 hidden 해제
			contents.style.maxHeight = contents.scrollHeight + 'px'
		}
		icon?.classList.add('active')
	}

	const toggle = (btn) => {
		const expanded = btn.getAttribute('aria-expanded') === 'true'
		if (expanded) {
			collapse(btn)
		} else {
			// 하나만 열리게 할 경우
			triggers.forEach((otherBtn) => {
				if (otherBtn !== btn) collapse(otherBtn)
			})
			expand(btn)
		}
	}

	triggers.forEach((btn) => {
		const contents = getContents(btn)
		btn.setAttribute('aria-expanded', 'false')
		if (contents) {
			contents.style.overflow = 'hidden'
			contents.style.transition = 'max-height 0.3s ease'
			contents.style.maxHeight = 0
			contents.hidden = true
		}
		getIcon(btn)?.classList.remove('active')
		btn.addEventListener('click', () => toggle(btn))
	})

	// 창 리사이즈 시 열려 있는 항목 높이 재계산
	window.addEventListener('resize', () => {
		triggers.forEach((btn) => {
			if (btn.getAttribute('aria-expanded') === 'true') {
				const contents = getContents(btn)
				if (contents) contents.style.maxHeight = contents.scrollHeight + 'px'
			}
		})
	})
})
